import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { TriggersListWrapper } from './triggers-list/TriggersList'

const triggerBreadCrumbs: Array<PageLink> = [
  {
    title: 'Triggers',
    path: '/triggers',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const TriggersPage = () => {
  return (
    <Routes>
     
      <Route index element={
            <>
              <PageTitle breadcrumbs={triggerBreadCrumbs}>Triggers list</PageTitle>
              <TriggersListWrapper />
            </>
          } />
    </Routes>
  )
}

export default TriggersPage
